export default "__VITE_ASSET__BGcNUedt__"